export default {"src":"/_next/static/media/BereavmentCategoryIcon.4cda049d.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};